import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe636102"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "我的设备", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查询我的订单", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "popup-content-wrap nongfu-button-wrap" }
const _hoisted_6 = { class: "confirm-button-line van-hairline--top" }
const _hoisted_7 = { key: 1 }

import { onMounted, Ref, ref, onDeactivated } from 'vue'
import { Button, List, PullRefresh, Popup, Loading } from 'vant'
import { useRouter } from 'vue-router'
import { getJijiaDeviceList, getJijiaDeviceDetail } from '@/apis/jijia'
import { XssCommonPageListQuery } from '@/types/public'
import {
  CacheSelectDeviceInfoKey,
  CacheSelectedContractAgree,
  CacheJijiaDeviceList,
} from '@/config/jijia'
import useCommonList, { PageParams, PageListResut } from '@/compositions/useCommonList'
import { BaseInfoListItem, DeviceListItem, GetJijiaDeviceListResultItem } from '@/types/jijia'
import AppHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import CostInfoItem from './components/cost-info-item.vue'
import BaseInfoList from './components/base-info-list.vue'
import DeviceCommonInfo from './components/device-common-info.vue'
import dayjs from 'dayjs'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'jijia-device',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function back() {
  AppHost.goAppBack()
}
const $router = useRouter()
const listKey = ref(String(Date.now()))
const showPopup = ref(false)
const loadingDetail = ref(false)
const currentItem: Ref<DeviceListItem | null> = ref(null)
let currentGuid = '' // 当前已经选择设备guid

function showPopupHandle(item: DeviceListItem) {
  currentItem.value = item
  currentGuid = item.guid
  showPopup.value = true
  initOrderItemDetail(item)
}
if (sessionStorage.getItem('jijiaDeviceListRefresh')) {
  sessionStorage.removeItem('CacheJijiaDeviceList')
  sessionStorage.removeItem('jijiaDeviceListRefresh')
}
async function initOrderItemDetail(item: DeviceListItem) {
  try {
    loadingDetail.value = true
    const data = await getJijiaDeviceDetail(item.guid)
    if (!showPopup.value || currentGuid !== data.guid) {
      // 如果此时
      return
    }
    const xcare = data.xcare
    const serviceInfoList: BaseInfoListItem[] = [
      { label: '设备型号', value: data.product_definition_name },
    ]
    const protectResult = {
      label: '保障服务时间',
      value: '',
    }
    if (!xcare.has_insurance && xcare.need_check_uav) {
      // 当前没有服务且需要验机的时候
      protectResult.value = '验机通过后1年（极加需验机）'
    } else if (xcare.has_insurance && xcare.insurance_end_at) {
      const startAt = xcare.insurance_end_at * 1000 + 86400000
      protectResult.value = `${dayjs(startAt).format('YYYY-MM-DD')} 至 ${dayjs(
        startAt + 31536000000
      ).format('YYYY-MM-DD')}（极加无需验机）`
    } else if (xcare.new_uav === 2) {
      protectResult.value = `${dayjs().format('YYYY-MM-DD')} 至 ${dayjs(
        Date.now() + 31536000000
      ).format('YYYY-MM-DD')}`
    }
    serviceInfoList.push(protectResult)
    serviceInfoList.push({
      label: '是否需要验机',
      value: xcare.need_check_uav ? '是' : '否',
    })
    currentItem.value = {
      ...item,
      serviceInfoList,
      buyInfo: {
        price: xcare.pay_amount + '',
      },
      ...data,
    }
  } catch (error) {
    console.log('error', error)
  }
  loadingDetail.value = false
}
function confirmBuy(item: DeviceListItem) {
  sessionStorage.setItem(CacheSelectDeviceInfoKey, JSON.stringify(currentItem.value))
  showPopup.value = false
  $router.push({
    name: 'jijia-introduce',
  })
}
function checkOrder() {
  $router.push({
    name: 'jijia-order-list',
  })
}
async function queryList(
  params: PageParams & XssCommonPageListQuery
): Promise<PageListResut<DeviceListItem>> {
  let data: GetJijiaDeviceListResultItem[] = []
  let cacheStr = sessionStorage.getItem(CacheJijiaDeviceList)
  try {
    data = cacheStr ? JSON.parse(cacheStr) : await getJijiaDeviceList(params)
    sessionStorage.setItem(CacheJijiaDeviceList, JSON.stringify(data))
    return {
      total: data.length,
      current_page: 1,
      data: data.map((item: GetJijiaDeviceListResultItem) => {
        const canBuy = item.xcare.can_insurance
        const xcare = item.xcare
        const serviceInfoList: BaseInfoListItem[] = [
          { label: '设备型号', value: item.product_definition_name },
        ]
        const suplusTime = xcare.has_insurance ? xcare.insurance_end_at * 1000 - Date.now() : 0
        if (xcare.has_insurance) {
          serviceInfoList.push({
            label: '剩余保障时间',
            value: `${Math.floor(suplusTime / 86400000)}天（${dayjs(
              parseInt(String(xcare.insurance_end_at * 1000))
            ).format('YYYY-MM-DD')}到期）`,
          })
          if (suplusTime < 604800000) {
            // 小于60天，需要进行提示
            serviceInfoList.push({
              type: 'notice',
              noticeInfo: {
                bgColor: 'rgba(255,144,43,0.12)',
                color: '#FF902B',
                text: '设备即将过保，请尽快续续费！',
                icon: 'icon-exclamation-mark',
              },
            })
          }
        } else {
          serviceInfoList.push({
            label: '剩余保障时间',
            value: '0天（已脱保）',
          })
          if (xcare.msg !== '该设备不可购买极加服务，如有疑问请咨询小美') {
            serviceInfoList.push({
              type: 'notice',
              noticeInfo: {
                bgColor: 'rgba(255,144,43,0.12)',
                color: '#FF902B',
                text: '设备无保障，面临较高使用风险及维修成本，建议尽快购买！',
                icon: 'icon-exclamation-mark',
              },
            })
          }
        }
        // if (xcare.can_insurance) {
        //   serviceInfoList.push({
        //     label: '是否需要验机',
        //     value: xcare.need_check_uav ? '是' : '否',
        //   })
        // }
        return {
          guid: item.guid,
          deviceCommonInfo: {
            img: item.logo,
            name: item.name,
            sequence: item.serial_number,
          },
          serviceInfoList,
          showBuy: canBuy,
          buyInfo: {
            price: xcare.pay_amount + '',
          },
          unBuyInfo: {
            text: xcare.msg,
          },
          xcare,
        }
      }),
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

const {
  refreshing,
  loading,
  requestError,
  finished,
  onRefresh,
  dataList,
  queryHandle,
  finishedText,
} = useCommonList<DeviceListItem, PageParams>(queryList, {})

function refreshHandle() {
  sessionStorage.removeItem(CacheJijiaDeviceList)
  onRefresh()
}
onMounted(() => {
  sessionStorage.removeItem(CacheSelectedContractAgree)
})
onDeactivated(() => {
  showPopup.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "极加服务",
      isReturnLeftEvent: "",
      onLeftClick: back
    }),
    _createElementVNode("div", { class: "title-line" }, [
      _hoisted_1,
      _createElementVNode("div", {
        class: "check-order",
        onClick: checkOrder
      }, _hoisted_4)
    ]),
    _createVNode(_unref(Popup), {
      show: showPopup.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showPopup).value = $event)),
      position: "bottom",
      round: "",
      "safe-area-inset-bottom": "",
      "close-on-popstate": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (currentItem.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (loadingDetail.value)
                  ? (_openBlock(), _createBlock(_unref(Loading), { key: 0 }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(DeviceCommonInfo, {
                        info: currentItem.value.deviceCommonInfo,
                        class: "width100"
                      }, null, 8, ["info"]),
                      _createVNode(BaseInfoList, {
                        list: currentItem.value.serviceInfoList,
                        class: "van-hairline--top width100"
                      }, null, 8, ["list"]),
                      _createVNode(CostInfoItem, {
                        class: "van-hairline--top cost-info-item width100",
                        buyInfo: currentItem.value.buyInfo
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(Button), {
                              class: "xa-vant-button cancel-button",
                              type: "success",
                              round: "",
                              block: "",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (showPopup.value = false))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("我再想想")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Button), {
                              class: "xa-vant-button",
                              type: "success",
                              round: "",
                              block: "",
                              onClick: confirmBuy
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下单购买")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["buyInfo"])
                    ], 64))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (_openBlock(), _createBlock(_unref(PullRefresh), {
      key: listKey.value,
      modelValue: _unref(refreshing),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
      onRefresh: refreshHandle,
      class: "list-wrap"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(List), {
          loading: _unref(loading),
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
          error: _unref(requestError),
          "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
          finished: _unref(finished),
          offset: 200,
          "finished-text": _unref(finishedText),
          "error-text": "加载失败",
          onLoad: _unref(queryHandle),
          class: "main-container"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card-container nongfu-button-wrap",
                key: item.guid || index
              }, [
                _createVNode(DeviceCommonInfo, {
                  info: item.deviceCommonInfo
                }, null, 8, ["info"]),
                _createVNode(BaseInfoList, {
                  list: item.serviceInfoList,
                  class: "van-hairline--top"
                }, null, 8, ["list"]),
                (item.showBuy)
                  ? (_openBlock(), _createBlock(CostInfoItem, {
                      key: 0,
                      showDefaualtContent: false,
                      class: "van-hairline--top cost-info-item",
                      buyInfo: item.buyInfo
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          class: "xa-vant-button",
                          type: "success",
                          round: "",
                          block: "",
                          onClick: ($event: any) => (showPopupHandle(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("立即购买")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["buyInfo"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(BaseInfoList, {
                        list: [{ label: item?.unBuyInfo?.text, value: '' }],
                        labelWidth: "100%",
                        class: "van-hairline--top"
                      }, null, 8, ["list"])
                    ]))
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "error", "finished", "finished-text", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue"]))
  ], 64))
}
}

})